module.exports = __webpack_public_path__ + "img/oddnary_bg.92d87184.jpg";